require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.11@core-js/fn/regexp/escape.js
// module id = 278
// module chunks = 0